module.exports = __webpack_public_path__ + "img/Ideological.08df2b76.png";